/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IsoCountry } from '../../models/iso-country';

export interface FindAll9$Params {
  page?: number;
  count?: number;
  sort?: string;
  dir?: 'ASC' | 'DESC';
  status?: 'ACTIVE' | 'INACTIVE';
}

export function findAll9(http: HttpClient, rootUrl: string, params?: FindAll9$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IsoCountry>>> {
  const rb = new RequestBuilder(rootUrl, findAll9.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('count', params.count, {});
    rb.query('sort', params.sort, {});
    rb.query('dir', params.dir, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<IsoCountry>>;
    })
  );
}

findAll9.PATH = '/api/values/countries';
